import React, {Component} from 'react'
import {observer} from 'mobx-react'

import SettingsGroup from '../../struct/SettingsGroup'

import ProfileCouponsSettings from './ProfileCouponsSettings'
import ProfileGiftsSettings from './ProfileGiftsSettings'
import ProfileNPlusMSettings from './ProfileNPlusMSettings'
import ProfileDiscountsSettings from './ProfileDiscountsSettings'
import ProfileBonusCardDiscountsSettings from './ProfileBonusCardDiscountsSettings'

import styles from './ProfilePromosSettings.less'

@observer export default class ProfilePromosSettings extends Component {
    render() {
        const {title} = this.props
        /** @type {ProfileSettingsContext} */
        const context = this.props.context

        return (
            <SettingsGroup title={title}>
                <div className={styles['settings-block']}>
                    <ProfileCouponsSettings context={context}/>
                </div>

                <div className={styles['settings-block']}>
                    <ProfileGiftsSettings context={context}/>
                </div>

                <div className={styles['settings-block']}>
                    <ProfileNPlusMSettings context={context}/>
                </div>

                <div className={styles['settings-block']}>
                    <ProfileDiscountsSettings context={context}/>
                </div>

                <div className={styles['settings-block']}>
                    <ProfileBonusCardDiscountsSettings context={context}/>
                </div>
            </SettingsGroup>
        )
    }
}